import React from 'react';
import { Button, Typography } from '@mui/joy';


export default function ButtonAttributeJoy({type,Bgcolor,color,bgColorHover,ColorHover,Label,startIcon,endIcon,width,height,hidden}){
    return (<Button
      type={type}
      
      fullWidth
      startDecorator={startIcon}
      endDecorator={endIcon}
      sx={{
        marginBottom: 2,
        padding: '12px 24px',
        width: width === null ? '100%' : width,
        height: height === null ? '56px' : height,
        borderRadius: '12px',
        backgroundColor: Bgcolor,
        
        transition: 'background-color 0.4s ease-in-out',
        '&:hover': {
          backgroundColor: bgColorHover,
          color: ColorHover,
        },
      }}
    >
      <Typography
        variant="body1"
        color={color}
        sx={{
          display: {
            xs: hidden ? 'none' : 'block',
            sm: hidden ? 'none' : 'block',
            md: 'block',
            lg: 'block',
            xl: 'block'
          },
          color: color,
          
        }}
      >
        {Label}
      </Typography>
    </Button>
    )
}
